import { PaymentMethod } from '@wix/cashier-common/dist/src/enums/payments/PaymentMethod';
import { Country } from '../../types/Country';
import { Currency } from '../../types/Currency';
import { ValidationRules } from './types';

const AFTERPAY_RULES: ValidationRules = {
  min: 1,
  max: 2000,
  currencies: [Currency.AUD, Currency.NZD, Currency.USD, Currency.CAD],
  countries: [Country.Australia, Country.NewZealand, Country.UnitedStates, Country.Canada],
  locales: ['en', 'fr'],
};

const CLEARPAY_RULES: ValidationRules = {
  min: 1,
  max: 1000,
  currencies: [Currency.GBP],
  countries: [Country.GreatBritain],
  locales: ['en'],
};

const LAYBUY_RULES: ValidationRules = {
  min: 1,
  currencies: [Currency.AUD, Currency.NZD, Currency.GBP],
  countries: [Country.Australia, Country.NewZealand, Country.GreatBritain],
  locales: ['en'],
};

const AFFIRM_RULES: ValidationRules = {
  min: 50,
  max: 30000,
  currencies: [Currency.USD],
  countries: [Country.UnitedStates],
  locales: ['en'],
};

const SEZZLE_RULES: ValidationRules = {
  min: 1,
  max: 2500,
  currencies: [
    Currency.AUD,
    Currency.CAD,
    Currency.EUR,
    Currency.GBP,
    Currency.HKD,
    Currency.ILS,
    Currency.MXN,
    Currency.NZD,
    Currency.USD,
    Currency.INR,
  ],
  countries: [
    Country.UnitedStates,
    Country.Canada,
    Country.GreatBritain,
    Country.Germany,
    Country.Austria,
    Country.France,
    Country.India,
  ],
  locales: ['en'],
};

const ATOME_RULES: ValidationRules = {
  min: 1,
  currencies: [Currency.SGD, Currency.MYR, Currency.HKD],
  countries: [Country.Singapore, Country.Malaysia, Country.HongKong],
  locales: ['en', 'zh'],
};

const CREDIT_CARD_INSTALLMENTS_RULES: ValidationRules = {
  min: 1,
  currencies: [Currency.BRL],
};

// should include all supported methods
export const VALIDATION_RULES: {
  [pm in PaymentMethod]?: ValidationRules;
} = {
  [PaymentMethod.Afterpay]: AFTERPAY_RULES,
  [PaymentMethod.Clearpay]: CLEARPAY_RULES,
  [PaymentMethod.Laybuy]: LAYBUY_RULES,
  [PaymentMethod.Affirm]: AFFIRM_RULES,
  [PaymentMethod.Sezzle]: SEZZLE_RULES,
  [PaymentMethod.Atome]: ATOME_RULES,
  [PaymentMethod.CreditCard]: CREDIT_CARD_INSTALLMENTS_RULES,
};
